import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';

export const HintsRoute: Route = {
  path: AppUrls.Dashboard._.Guide._.Hints.relativeUrl,
  children: [
    {
      path: AppUrls.Dashboard._.Guide._.Hints._.HintList.relativeUrl,
      loadComponent: () => import('./hint-list/hint-list.component').then(_ => _.HintListComponent),
      pathMatch: 'full',
    },
    {
      path: AppUrls.Dashboard._.Guide._.Hints._.HintEditor.relativeUrl,
      loadComponent: () => import('./hint-editor/hint-editor.component').then(_ => _.HintEditorComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Guide._.Hints._.HintList.relativeUrl,
    },
  ],
};
